import { createContext } from 'react'

export const TweetListContext = createContext([])
export const UserContext = createContext("")